const display = document.getElementById('heart-display');
const fillLayer = document.getElementById('heart-fill-layer');
const COLS = 100;
const ROWS = 40;
const zb = new Float64Array(COLS * ROWS);
const chars = " .,-~:;=!*#$@@";
let t = 0;
let heartSpeed = 0.015;
let heartColor = null;

// 填充進度 0~1，供 lottery.js 控制
window.heartFillLevel = 0;
// 填充完成後的顏色模式
let fillComplete = false;

// 供外部呼叫：每次點擊時的小跳動（只改速度和光暈）
window.heartBeat = function () {
    heartSpeed = 0.06;
    display.style.textShadow = '0 0 15px rgba(255, 100, 150, 0.6)';
    setTimeout(() => {
        heartSpeed = 0.025;
        display.style.textShadow = '0 0 8px rgba(255, 100, 150, 0.3)';
    }, 300);
    setTimeout(() => {
        heartSpeed = 0.015;
        display.style.textShadow = '';
    }, 800);
};

// 供外部呼叫：填滿完成時的大跳動
window.heartFillComplete = function () {
    fillComplete = true;
    heartSpeed = 0.06;
    display.style.textShadow = '0 0 25px rgba(255, 100, 150, 0.8)';
    setTimeout(() => {
        heartSpeed = 0.02;
    }, 1000);
};

// 供外部呼叫：重置愛心到初始狀態
window.heartReset = function () {
    fillComplete = false;
    heartColor = null;
    heartSpeed = 0.015;
    display.style.textShadow = '';
    display.style.color = '';
    fillLayer.style.clipPath = 'inset(100% 0 0 0)';
    fillLayer.style.color = '#ff4080';
};

// 供外部呼叫：中獎時的金色效果
window.heartGold = function () {
    heartColor = '#ffd700';
    heartSpeed = 0.06;
    display.style.textShadow = '0 0 30px rgba(255, 215, 0, 0.8)';
};

function forever() {
    const width = screen.width;
    const scaleFactor = width < 600 ? 0.6 : 1.0;

    zb.fill(-999);
    let maxz = 0.0001;

    const c = Math.cos(t), s = Math.sin(t);

    let loveSafetyCounter = 0;
    const MAX_LOVE = 1000000;

    try {
        for (let y = -0.5; y <= 0.5; y += 0.01) {
            const r = 0.4 + 0.05 * Math.pow(0.5 + 0.5 * Math.sin(t * 6 + y * 2), 8);

            for (let x = -0.5; x <= 0.5; x += 0.01) {
                let zSq = -x * x - Math.pow(1.2 * y - Math.abs(x) * 2 / 3, 2) + r * r;
                if (zSq < 0) continue;

                let z = Math.sqrt(zSq) / (2 - y);
                let step = z / 6;
                if (step <= 0) continue;

                for (let tz = -z; tz <= z; tz += step) {
                    loveSafetyCounter++;
                    if (loveSafetyCounter > MAX_LOVE) {
                        throw new Error("偵測到熱情過量，強制停止以防作夢笑醒");
                    }

                    const nx = x * c - tz * s;
                    const nz = x * s + tz * c;
                    const p = 1 + nz / 2;
                    const vx = Math.round((nx * p * scaleFactor + 0.5) * 80 + 10);
                    const vy = Math.round((-y * p * scaleFactor + 0.5) * 39 + 2);

                    const idx = vx + vy * COLS;
                    if (idx >= 0 && idx < COLS * ROWS) {
                        if (zb[idx] <= nz) {
                            zb[idx] = nz;
                            if (maxz < nz) maxz = nz;
                        }
                    }
                }
            }
        }

        // 生成純文字（永遠只用 textContent，不用 innerHTML）
        let plain = "";
        for (let i = 0; i < COLS * ROWS; i++) {
            if (i % COLS === 0 && i !== 0) plain += "\n";
            const val = zb[i];
            const charIdx = val === -999 ? 0 : Math.round((val / maxz) * (chars.length - 1));
            plain += chars[Math.max(0, Math.min(charIdx, chars.length - 1))];
        }

        // 底層：白色（或特殊顏色）
        display.textContent = plain;

        if (heartColor) {
            display.style.color = heartColor;
            fillLayer.style.clipPath = 'inset(100% 0 0 0)';
        } else if (fillComplete) {
            display.style.color = '#ff4080';
            fillLayer.style.clipPath = 'inset(100% 0 0 0)';
        } else {
            display.style.color = '';
        }

        // 上層：粉色填充，用 clip-path 從底部往上顯示
        const fillLevel = window.heartFillLevel;
        if (fillLevel > 0 && !fillComplete && !heartColor) {
            fillLayer.textContent = plain;
            const clipTop = (1 - fillLevel) * 100;
            fillLayer.style.clipPath = `inset(${clipTop}% 0 0 0)`;
        } else if (!fillComplete && !heartColor) {
            fillLayer.style.clipPath = 'inset(100% 0 0 0)';
        }

        t += heartSpeed;
        requestAnimationFrame(forever);

    } catch (e) {
        console.error("[Fatal Error]", e.message);
        display.textContent = "偵測到異常，請開啟 Console 或去睡一覺。";
    }
}

console.log("驚喜啟動中...");
forever();
